export default async (context) => {

    let day = await context.$store.getters['date/day']
    let month = await context.$store.getters['date/month']
    let year = await context.$store.getters['date/year']

    if(day < 10) {
        day = `0${day}`
    }

    if(month < 10) {
        month = `0${month}`
    }

    let time = `${day}.${month}.${year}`

    let type = ''

    if(context.priceSurveyName === 'Съёмка с земли') {
        type = 'ground'
    } else if(context.priceSurveyName === 'Съёмка с воздуха') {
        type = 'air'
    } else if(context.priceSurveyName === 'Все виды съемок') {
        type = 'ground_and_air'
    }


    let data = {
        phone: await context.$store.getters['auth/phone'],
        tocken: await context.$store.getters['auth/token'],
        theme: await context.$store.getters['theme/theme'].id,
        date: time,
        time: await context.$store.getters['date/selectTime'],
        music: context.checkMusicId,
        record: type,
        videos: context.videos
    }

    await context.$axios.post(`/createOrder`, data)
        .then(async ( {data} ) => {
            if(data.success) {
                context.is_other_date = false
                context.overlay = false
                context.error.status = false
                context.error.text_button = 'ОК'
                context.error.text = ''
                context.$store.dispatch('price/restPrice', {
                    data: data.price
                })
                context.$store.dispatch('auth/setOrder', {
                    order: data.order
                })

                await context.$store.dispatch('auth/setIsCreatedOrder', {
                    status: true
                })

                context.$router.push('/payment')
            } else {
                context.overlay = true
                context.error.text = data.error
                if(context.error.text === 'Выбранное время не доступно') {
                    context.error.text_button = 'Выбрать другую дату'
                    context.is_other_date = true
                }
                context.error.status = true
                context.auth_code_clear_form(context)
            }
        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
            context.auth_code_clear_form(context)
        })
}